__turbopack_context__.v({
  "banner": "HomeSkeleton-module-scss-module__ljTa8a__banner",
  "banners": "HomeSkeleton-module-scss-module__ljTa8a__banners",
  "button": "HomeSkeleton-module-scss-module__ljTa8a__button",
  "image": "HomeSkeleton-module-scss-module__ljTa8a__image",
  "links": "HomeSkeleton-module-scss-module__ljTa8a__links",
  "name": "HomeSkeleton-module-scss-module__ljTa8a__name",
  "page": "HomeSkeleton-module-scss-module__ljTa8a__page",
  "price": "HomeSkeleton-module-scss-module__ljTa8a__price",
  "product": "HomeSkeleton-module-scss-module__ljTa8a__product",
  "search": "HomeSkeleton-module-scss-module__ljTa8a__search",
  "second-banner": "HomeSkeleton-module-scss-module__ljTa8a__second-banner",
  "stories": "HomeSkeleton-module-scss-module__ljTa8a__stories",
  "story": "HomeSkeleton-module-scss-module__ljTa8a__story",
  "top": "HomeSkeleton-module-scss-module__ljTa8a__top",
});
